import {LogLevel, Configuration, BrowserCacheLocation} from "@azure/msal-browser";

const isIE = window.navigator.userAgent.indexOf("MSIE") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

const MSAL_CLIENT_ID = "40ef7d2e-fdad-4fdc-9994-aeacc1620a31";
const MSAL_TENANT_ID = "deb6d075-c03c-4842-8ca2-578ce1ef5354";

export const msalConfig: Configuration = {
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: "https://login.microsoftonline.com/" + MSAL_TENANT_ID,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: isIE
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message)
      },
      piiLoggingEnabled: false
    }
  }
}
